/**
 * Consistent org-picker copy: short title (appTitle) + optional full name (displayName).
 */

function normalize(value) {
  return String(value || '').trim();
}

function labelsDiffer(a, b) {
  return normalize(a).localeCompare(normalize(b), 'sl', { sensitivity: 'accent' }) !== 0;
}

/**
 * @param {{ displayName?: string, tenantId?: string, branding?: { appTitle?: string } } | null | undefined} config
 * @returns {{ shortTitle: string, subtitle: string | null }}
 */
export function getOrganizationCardLabels(config) {
  const displayName = normalize(config?.displayName) || normalize(config?.tenantId);
  const appTitle = normalize(config?.branding?.appTitle);
  const shortTitle = appTitle || displayName;
  const subtitle = appTitle && labelsDiffer(appTitle, displayName) ? displayName : null;

  return { shortTitle, subtitle };
}
